import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IPostSenhaBody,
  IApiResponse,
  IPostSenhaResponseData,
  IPutSenhaBody,
  IPutAlterarSenhaUsuarioLogadoBody,
  IPutAlterarSenhaBody
} from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class SenhaService {
  private readonly baseURL = '/Senha';
  constructor(private httpClient: HttpClient) {}

  postSenha(body: IPostSenhaBody) {
    return this.httpClient.post<IApiResponse<IPostSenhaResponseData>>(
      this.baseURL,
      body
    );
  }

  putSenha(body: IPutSenhaBody) {
    return this.httpClient.put<IApiResponse>(this.baseURL, body);
  }

  putAlterarSenhaUsuarioLogado(body: IPutAlterarSenhaUsuarioLogadoBody) {
    return this.httpClient.put<IApiResponse>(
      `${this.baseURL}/AlterarSenhaUsuarioLogado`,
      body
    );
  }

  putAlterarSenha(body: IPutAlterarSenhaBody) {
    return this.httpClient.put<IApiResponse>(
      `${this.baseURL}/AlterarSenha`,
      body
    );
  }
}
